import React, { Component } from 'react';
import Base from '../rebase';
import {
  Nav,
  Navbar,
  NavItem
} from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';

class NavigationBar extends Component {

  constructor(props) {
    super(props);
    this.state = {
      topNav: [],
    };
  }

  componentWillMount() {
    this.ref = Base.fetch('pages', {
      context: this,
      asArray: true,
      queries: {
        orderByChild: 'order'
      }
    })
    .then(data => {
      this.setState({topNav: data});
    })
    .catch(error => {
      console.log("NavigationBar.jsx" + error);
    });
  }

  render() {
  	return (
  		<Navbar collapseOnSelect>
            <Navbar.Toggle />
            <Navbar.Collapse>
              <Nav>
                {
                  this.state.topNav.map((nav, index) => (
                    <LinkContainer key={nav.link+"LinkContainer"} to={"/"+nav.link}>
                      <NavItem key={nav.link+"navItem"}>{nav.title}</NavItem>
                    </LinkContainer>
                  ))
                }
              </Nav>
            </Navbar.Collapse>
          </Navbar>
  	)
  }

}

export default NavigationBar;


// WEBPACK FOOTER //
// ./src/reusable_components/NavigationBar.jsx